
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import VueImageCropUpload from 'vue-image-crop-upload';

import { Action, State } from 'vuex-class';

import { data2blob, language } from '@/functions/imagecrop.function';

@Component({
  components: {
    VueImageCropUpload,
  },
})
export default class FileBannerInputJobsFair extends Vue {
  /* VUEX */

  // STATE

  @State('locale')
  private locale: any;

  /* PROP */

  @Prop({ default: '' })
  private banner: any;
  @Prop({ default: '' })
  private status: any;

  private url: any | null = null;
  private showUpload: boolean = false;
  private languageCropImage: any = language;

  constructor() {
    super();
  }

  /* INITIALIZATION */

  @Watch('banner')
  private removeBannerOnClose() {
    if (typeof(this.banner) === 'string' && this.banner === '' && this.status === 'create') {
      this.url = null;
      this.$emit('update:banner', null);
    }
  }

  @Watch('locale')
  private onLocaleChange() {
    (this.$refs.fileBannerInputJobsFair as any).lang = this.languageCropImage[this.locale];
  }

  private created() {
    if (typeof(this.banner) === 'string' && this.banner !== '') {
      this.url = this.banner;
    }
  }

  private mounted() {
    (this.$refs.fileBannerInputJobsFair as any).lang = this.languageCropImage[this.locale];
  }

  private onChangeBanner(e: any) {
    const file = e.target.files[0];
    this.$emit('update:banner', file);
    this.url = URL.createObjectURL(file);
  }

  /**
   * Handling Success Crop Image
   */
  private cropBannerSuccess(imageDataUrl: any) {
    const elImageCropUpload = (this.$refs.fileBannerInputJobsFair as any);
    const blobFile = data2blob(imageDataUrl, (elImageCropUpload.mime as string));
    const fileName = Date.now().toString() + '-banner' + '.' + elImageCropUpload.imgFormat;
    const file = new File([blobFile], fileName);
    this.showUpload = false;
    this.$emit('update:banner', file);
    this.url = URL.createObjectURL(file);
  }

  private removeBanner() {
    (this.$refs.fileBannerInputJobsFair as any).value = null;
    this.url = null;
    this.$emit('update:banner', null);
  }
}
